import styles from './ModalForgotPassword.module.css';

import { useForm } from 'react-hook-form';
import Modal from 'react-responsive-modal';

import { Button } from '../../../../components/Button';
import { Notify } from '../../../../components/Notify';
import { Input } from '../../../../components/forms/Input';
import { api } from '../../../../server/api';

interface IModalForgotPassword {
  clientId: string;
  modalIsOpen: boolean;
  toggleModal: () => void;
}

interface FormValues {
  email: string;
}

export function ModalForgotPassword({
  clientId,
  modalIsOpen,
  toggleModal,
}: IModalForgotPassword) {
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const getPlayerByEmail = async (email: string) => {
    try {
      const parameters = {
        searchFunctionality: 'getPlayerByEmail',
        userType: 'player',
        clientId,
        searchEmail: email,
      };

      const { data } = await api.post('/search', parameters);

      return { success: data.success };
    } catch (error) {
      console.log('getPlayerByEmail error', error);
      return { success: false };
    }
  };

  const sendPasswordResetEmail = async (email: string) => {
    try {
      const hostname = window.location.host;
      const parameters = {
        searchFunctionality: 'sendPasswordResetEmail',
        userType: 'player',
        clientId,
        playerEmail: email,
        hostname,
      };

      await api.post('/search', parameters);
    } catch (error) {
      console.log('sendPasswordResetEmail error', error);
    }
  };

  const recoverPassword = async (email: string) => {
    try {
      await sendPasswordResetEmail(email);
      // await firebase.auth().sendPasswordResetEmail(email);

      setValue('email', '');
      toggleModal();

      Notify(
        `Encaminhamos para o email ${email} as instruções para recuperação da senha`,
        'success'
      );
    } catch (error) {
      console.log('recoverPassword error', error);
      Notify(
        'Tivemos um problema para enviar o e-mail com as instruções para recuperação da senha, verifique o e-mail informado ou tente novamente mais tarde!',
        'error'
      );
    }
  };

  const handleForm = handleSubmit(async (data) => {
    const { success } = await getPlayerByEmail(data.email);
    // console.log(
    //   '🚀 ~ file: index.tsx ~ line 32 ~ handleForm ~ success',
    //   success
    // );
    if (success) {
      await recoverPassword(data.email);
    } else {
      Notify(`Não encontramos o player com o email inserido!`, 'error');
    }
  });

  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <form onSubmit={handleForm}>
        <div className="contents-modal">
          <h1 className="title-modal">Recuperar senha</h1>
          <p className="subtitle-modal">
            Informe seu e-mail para prosseguirmos com a recuperação da sua
            conta.
          </p>
          <div className="mb-3 mt-3">
            <Input
              type="text"
              placeholder="E-mail cadastrado"
              errors={errors.email ? 'Campo de email obrigatório' : ''}
              {...register('email', {
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid email address',
                },
              })}
              aria-invalid={errors.email ? 'true' : 'false'}
            />
          </div>
        </div>
        <div className={styles.contentBtn}>
          <Button
            isModal
            text={isSubmitting ? 'Resetando ...' : 'Recuperar a senha'}
            type="submit"
            color="primary"
          />
        </div>
      </form>
    </Modal>
  );
}
